module.exports = __webpack_public_path__ + "media/assets/images/flags/pk-f4fbddc7b91a944bd44c8525b8103729.svg";